import React, { createContext, useState } from "react";
import { toast } from "react-toastify";
import useToggleStyle from "../../hooks/useToggleStyle";
import { isJsonString } from "../../utils/helpers/utils";

type UserType = {
  isUserLoggedIn: boolean;
  user: {};
  token: string;
  isInitialized: boolean;
};

interface AppContextInterface {
  config: any;
  setConfig: (key: any, value: any) => void;
  user: UserType;
  setUser: (d: UserType) => void;
  checkUserLog: () => void;
}

export const AppContext = createContext<AppContextInterface>({
  config: {},
  setConfig: (data: any) => {},
  user: {
    isUserLoggedIn: false,
    user: {},
    token: "",
    isInitialized: false,
  },
  setUser: (data: UserType) => {},
  checkUserLog: () => {},
});

const useAppContext = () => {
  const [user, setUser] = useState({
    isUserLoggedIn: false,
    user: {},
    token: "",
    isInitialized: false,
  });
  const userHandler = (data: UserType) => {
    setUser({ ...data });
  };

  const [data, setData] = useState({
    isFluid: false,
    isRTL: false,
    isDark: false,
    navbarPosition: "vertical",
    showBurgerMenu: false, // controls showing vertical nav on mobile
    currency: "$",
    isNavbarVerticalCollapsed: false, // toggle vertical navbar collapse
    navbarStyle: "transparent",
  });
  const { isLoaded } = useToggleStyle(data.isRTL, data.isDark);
  const configHandler = (key: any, value: any) => {
    setData({ ...data, [key]: value });
  };

  const checkUserLogHandler = () => {
    try {
      const token = window.localStorage.getItem("token") ?? "";
      const user = window.localStorage.getItem("user") ?? "";
      const isUserLoggedInTmp =
        window.localStorage.getItem("isUserLoggedIn") ?? "false";
      if (isUserLoggedInTmp === "true" && token && user && isJsonString(user)) {
        const jsonUser: Object = JSON?.parse(user);
        setUser({
          isUserLoggedIn: true,
          user: jsonUser,
          token: token,
          isInitialized: true,
        });
      } else {
        setUser({
          isUserLoggedIn: false,
          user: {},
          token: "",
          isInitialized: true,
        });
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("user");
      }
    } catch (error) {
      toast.error("err");
    }
  };

  const value = {
    config: data,
    setConfig: configHandler,
    user: user,
    setUser: userHandler,
    checkUserLog: checkUserLogHandler,
  };

  return value;
};

export default useAppContext;
